import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { ClientList } from "../../../components/Client";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";

export interface IClientListPage {}

export const ClientListPage: FC<IClientListPage> = (
  props: IClientListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Client List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ClientList />}
    />
  );
};
